import { IPhoneNumber } from './phone-number.model';
import { countriesInfo } from '../data/phone-number-flags.constants';

export interface ICountryInfo {
  name: string;
  code: string;
  emoji: string;
  unicode: string;
  image: string;
  dial_code: string;
  // validator?: ICountryCodeValidator;
}

export interface PhoneNumberValue {
  countryCode: string;
  number: string;
}

export interface PhoneNumberProps {
  label?: string;
  placeholder?: string;
  required?: boolean;
  mobileNumberCode?: string;
  hint?: string;
  defaultValue: PhoneNumberValue;
  pattern?: string;
}

export const flagSourceUrl = 'https://country-code-au6g.vercel.app';
export class CountryInfo implements ICountryInfo {
  name: string;
  code: string;
  emoji: string;
  unicode: string;
  image: string;
  dial_code: string;

  private constructor(countryInfo: ICountryInfo) {
    this.name = countryInfo.name;
    this.code = countryInfo.code;
    this.emoji = countryInfo.emoji;
    this.unicode = countryInfo.unicode;
    this.image = countryInfo.image;
    this.dial_code = countryInfo.dial_code;
  }

  static getCountryInfo(phoneNumber: IPhoneNumber | undefined): ICountryInfo | undefined {
    let countryInfo = countriesInfo.find((x) => x.dial_code == phoneNumber?.countryCode);

    if (countryInfo) {
      let ci = new CountryInfo(countryInfo);
      ci.image = `${flagSourceUrl}/${countryInfo.image}`;
      return ci;
    }

    return undefined;
  }
}
